var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99995 10.8867C6.40661 10.8867 5.11328 9.59334 5.11328 8.00001C5.11328 6.40668 6.40661 5.11334 7.99995 5.11334C9.59328 5.11334 10.8866 6.40668 10.8866 8.00001C10.8866 9.59334 9.59328 10.8867 7.99995 10.8867ZM7.99995 6.11334C6.95995 6.11334 6.11328 6.96001 6.11328 8.00001C6.11328 9.04001 6.95995 9.88668 7.99995 9.88668C9.03995 9.88668 9.88661 9.04001 9.88661 8.00001C9.88661 6.96001 9.03995 6.11334 7.99995 6.11334Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0007 14.0133C5.49404 14.0133 3.12737 12.5467 1.5007 10C0.794036 8.9 0.794036 7.10666 1.5007 6C3.13404 3.45333 5.5007 1.98666 8.0007 1.98666C10.5007 1.98666 12.8674 3.45333 14.494 6C15.2007 7.1 15.2007 8.89333 14.494 10C12.8674 12.5467 10.5007 14.0133 8.0007 14.0133ZM8.0007 2.98666C5.84737 2.98666 3.78737 4.28 2.34737 6.54C1.84737 7.32 1.84737 8.68 2.34737 9.46C3.78737 11.72 5.84737 13.0133 8.0007 13.0133C10.154 13.0133 12.214 11.72 13.654 9.46C14.154 8.68 14.154 7.32 13.654 6.54C12.214 4.28 10.154 2.98666 8.0007 2.98666Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.5d8b302ea333fc7106772210b681226c.svg";
export { ForwardRef as ReactComponent };